import { Box, Typography, Container } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const brandBlue = "#1a237e";
const brandRed = "#d50000";

export default function CompanyHistory() {
  const events = [
    {
      year: "2015",
      text: "Burj Al Yarmouk Industries LLC established in Sharjah, UAE.",
    },
    {
      year: "2015–2020",
      text: "Major expansion in acoustic enclosures, fuel tank manufacturing & steel structural fabrication.",
    },
    {
      year: "2020–2023",
      text: "Achieved ISO 9001, ISO 14001, ISO 45001 certifications. Expanded production capacity, workforce, and machinery.",
    },
    {
      year: "2024–2025",
      text: "Serving leading power, industrial, oil & gas, metal industries across UAE & GCC.",
    },
  ];

  return (
    <Box sx={{ py: { xs: 8, md: 12 }, backgroundColor: "#f9f9ff" }}>
      <Container maxWidth="lg">
        {/* Heading */}
        <Typography
          variant="h4"
          fontWeight={800}
          sx={{
            mb: 2,
            color: brandBlue,
            fontSize: { xs: "1.8rem", md: "2.3rem" },
          }}
        >
          Company History & Journey
        </Typography>
        <Box
          sx={{
            width: "70px",
            height: "4px",
            background: brandRed,
            borderRadius: 2,
            mb: 5,
          }}
        />

        {/* Timeline */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 6 }}>
          {events.map((e, i) => (
            <Box
              key={i}
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: 3,
                position: "relative",
              }}
            >
              {/* Icon + Line */}
              <Box
                sx={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {/* Icon */}
                <Box
                  sx={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    background: brandBlue,
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    zIndex: 2,
                  }}
                >
                  <AccessTimeIcon />
                </Box>

                {/* Vertical Line */}
                {i !== events.length - 1 && (
                  <Box
                    sx={{
                      width: "4px",
                      height: "100%", // make line full height of text box
                      background: brandBlue,
                      borderRadius: 2,
                      mt: 1,
                      position: "absolute",
                      top: "60px",
                    }}
                  />
                )}
              </Box>

              {/* Text Content */}
              <Box
                sx={{
                  p: 3,
                  background: "white",
                  borderRadius: 2,
                  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                  flex: 1,
                  transition: "0.3s",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: "0 8px 25px rgba(26,35,126,0.2)",
                  },
                }}
              >
                <Typography
                  variant="h6"
                  fontWeight={600}
                  sx={{ color: brandBlue, mb: 1 }}
                >
                  {e.year}
                </Typography>
                <Typography sx={{ color: "text.secondary", lineHeight: 1.7 }}>
                  {e.text}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
